var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f7:exclamationmark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5004 18.5386C15.1629 18.5386 19.0382 14.6715 19.0382 10.0007C19.0382 5.33825 15.1543 1.46289 10.4918 1.46289C5.82146 1.46289 1.96289 5.33825 1.96289 10.0007C1.96289 14.6715 5.82968 18.5386 10.5004 18.5386ZM10.5007 17.1157C6.54932 17.1157 3.39325 13.9515 3.39325 10.0007C3.39325 6.05789 6.54075 2.88575 10.4918 2.88575C14.4343 2.88575 17.6065 6.05825 17.615 10.0007C17.6232 13.9518 14.4425 17.1157 10.5 17.1157M10.4918 11.5157C10.8932 11.5157 11.1193 11.2897 11.1275 10.8547L11.2532 6.43503C11.2618 6.00789 10.9268 5.69003 10.4832 5.69003C10.0311 5.69003 9.71325 5.99968 9.72146 6.42646L9.83039 10.8547C9.8386 11.2815 10.0732 11.5157 10.4918 11.5157ZM10.4918 14.2361C10.9686 14.2361 11.3954 13.8511 11.3954 13.3657C11.3954 12.8718 10.9772 12.495 10.4918 12.495C9.99789 12.495 9.58753 12.88 9.58753 13.3657C9.58753 13.8429 10.0061 14.2361 10.4918 14.2361Z",
    fill: "#F44336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationmarkCircle);
export default __webpack_public_path__ + "static/media/exclamationmark-circle.bdd7b660e891a42923415c4ae0526c78.svg";
export { ForwardRef as ReactComponent };